module.exports = __webpack_public_path__ + "img/fruit-tomatillos-350x184.7a8333e6.jpg";